import "./App.css";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";

import Aos from "aos";
import Dashboard from "./screens/Dashboard";
import Toast from "./components/Notifications/Toast";
import Payments from "./screens/Payments/Payments";
import Appointments from "./screens/Appointments";
import Patients from "./screens/Patients/Staff";
import Campaings from "./screens/Campaings";
import Services from "./screens/ServicesBeauty";
import Invoices from "./screens/Invoices/Invoices";
import Settings from "./screens/Settings";
import CreateInvoice from "./screens/Invoices/CreateInvoice";
import EditInvoice from "./screens/Invoices/EditInvoice";
import PreviewInvoice from "./screens/Invoices/PreviewInvoice";
import EditPayment from "./screens/Payments/EditPayment";
import PreviewPayment from "./screens/Payments/PreviewPayment";
import Medicine from "./screens/Medicine";
import PatientProfile from "./screens/Patients/StaffProfile";
import CreatePatient from "./screens/Patients/CreatePatient";
import Doctors from "./screens/Doctors/Doctors";
import DoctorProfile from "./screens/Doctors/DoctorProfile";
import Receptions from "./screens/Receptions";
import NewMedicalRecode from "./screens/Patients/NewMedicalRecode";
import NotFound from "./screens/NotFound";
import Login from "./screens/Login";
import AuthModal from "./components/AuthModal/AuthModal";
import PrivateRoute from "./PrivateRoute";
import ServicesNails from "./screens/ServicesNails";
import ServicesBeauty from "./screens/ServicesBeauty";
import Staff from "./screens/Patients/Staff";
import StaffProfile from "./screens/Patients/StaffProfile";
import AppointmentDetail from "./screens/AppointmentDetail";
import CustomerDetail from "./screens/Customer/CustomerDetail";
import DetailBooking from "./screens/DetailBooking/DetailBooking";
import ListofCustomers from "./screens/Customer/ListofCustomers";
import ListofBooking from "./screens/DetailBooking/ListofBooking";
import WalkInBooking from "./screens/WalkInBooking/WalkInBooking";
import BookingModify from "./screens/WalkInBooking/BookingModify";
import { Navigate } from "react-router-dom"; // Add this at top of App.js
import SectionExpiredModal from "./components/SectionExpiredModal/SectionExpiredModal";
import Roster from "./screens/Roster/Roster";
import ClosedDate from "./screens/Roster/ClosedDate";
import Ordering from "./screens/Orders/Ordering";
import OrderDetail from "./screens/OrderDetail/OrderDetail";
import BookingServices from "./screens/BookingServices/BookingServices";
import SingleService from "./screens/BookingServices/SingleService";
import BundleService from "./screens/BookingServices/BundleService";
import EditService from "./screens/BookingServices/EditService";

function App() {
  Aos.init();

  return (
    <>
      <Toast />
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          {/* Private Routes */}
          <Route element={<PrivateRoute />}>
            <Route path="/" element={<Navigate to="/ordering" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            {/* invoce */}
            <Route path="/invoices" element={<Invoices />} />
            <Route path="/invoices/create" element={<CreateInvoice />} />
            <Route path="/invoices/edit/:id" element={<EditInvoice />} />
            <Route path="/invoices/preview/:id" element={<PreviewInvoice />} />
            {/* payments */}
            <Route path="/payments" element={<Payments />} />
            <Route path="/payments/edit/:id" element={<EditPayment />} />
            <Route path="/payments/preview/:id" element={<PreviewPayment />} />
            {/* patient */}
            <Route path="/staffs" element={<Staff />} />
            <Route path="/staff/preview/:id" element={<StaffProfile />} />

            <Route path="/staff/create" element={<CreatePatient />} />
            <Route path="/staff/visiting/:id" element={<NewMedicalRecode />} />
            {/* customer */}
            <Route path="/customer/preview/:id" element={<CustomerDetail />} />

            <Route path="/customers" element={<ListofCustomers />} />

            {/* ordering */}

            <Route path="/ordering" element={<Ordering />} />
            <Route path="/order/preview/:id" element={<OrderDetail />} />

            <Route path="/listofbooking" element={<ListofBooking />} />
            <Route path="/booking/preview/:id" element={<DetailBooking />} />
            <Route path="/booking/reschedule/:id" element={<BookingModify />} />

            <Route path="/book/create" element={<WalkInBooking />} />

            {/* doctors */}
            <Route path="/doctors" element={<Doctors />} />
            <Route path="/doctors/preview/:id" element={<DoctorProfile />} />
            {/* reception */}
            <Route path="/receptions" element={<Receptions />} />
            {/* others */}
            <Route path="/appointments" element={<Appointments />} />
            <Route path="/appointments/:id" element={<AppointmentDetail />} />
            <Route path="/campaigns" element={<Campaings />} />
            <Route path="/medicine" element={<Medicine />} />
            <Route path="/nailservices" element={<ServicesNails />} />
            <Route path="/beautyservices" element={<ServicesBeauty />} />

            {/* Service Food Items */}
            <Route path="/services" element={<BookingServices />} />
            <Route path="/food/item/add/new" element={<SingleService />} />
            <Route path="/food/item/edit/:id" element={<SingleService />} />
            <Route
              path="/food/item/package/add/new"
              element={<BundleService />}
            />

            {/* roster */}
            <Route path="/rosters" element={<Roster />} />
            <Route path="/roster/closed" element={<ClosedDate />} />

            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
        <AuthModal />
        <SectionExpiredModal />
      </BrowserRouter>
    </>
  );
}

export default App;
